<div class="row">
  <!-- Palette button — the chip rail's compact-density stand-in. -->
  <button
    *ngIf="showPaletteButton"
    type="button"
    class="row__btn"
    aria-label="Open workflow palette"
    (click)="paletteToggled.emit()"
  >
    ⌗
  </button>

  <label class="row__field" [class.row__field--listening]="micActive">
    <span class="row__sr">Message BB</span>
    <input
      #field
      type="text"
      class="row__input"
      [attr.placeholder]="placeholder"
      [value]="value"
      (input)="onInput($any($event.target).value)"
      (keydown.enter)="onEnter()"
      (keydown.escape)="onEscape()"
      autocomplete="off"
    />
    <!-- Partial transcript sits in grey behind the caret until it commits. -->
    <span class="row__transcript" *ngIf="transcript">{{ transcript }}</span>
  </label>

  <button
    *ngIf="showTtsToggle"
    type="button"
    class="row__btn"
    [class.row__btn--on]="ttsEnabled"
    [attr.aria-pressed]="ttsEnabled"
    [attr.aria-label]="ttsLabel"
    (click)="ttsToggled.emit()"
  >
    ◍
  </button>

  <button
    type="button"
    class="row__mic"
    [class.row__mic--tinted]="micVariant === 'tinted'"
    [class.row__mic--active]="micActive"
    [class.row__mic--handsfree]="handsFree"
    [attr.aria-pressed]="micActive"
    [attr.aria-label]="micLabel"
    (pointerdown)="onMicDown()"
    (pointerup)="onMicUp()"
    (pointerleave)="onMicCancel()"
    (pointercancel)="onMicCancel()"
  >
    ⏺
  </button>
</div>
